import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { LicenseType } from "@shared-features/enums/license-type.enum";
import { Nationality } from "@shared-features/enums/nationality.enum";

export class Elm extends Model {
  @Expose() firstName: string;
  @Expose() lastName: string;
  @Expose() iqamaExpiryDate: Date;
  @Expose() licenseExpiryDate: Date;
  @Expose() licenseType: LicenseType;
  @Expose() nationality: Nationality;
  @Expose() owner: string;
  @Expose() issueNumber: number;
  @Expose() elmObj: any;

  constructor() {
    super();
  }
}
